import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { useGetAccountUserSettingsQuery } from '../store/accountUserSettings/accountUserSettings'
import { DEFAULT_TIMEZONE } from '../components/TimezoneSelector/constants'

export function useAccountTimezone(): string {
  const accountId = useAppSelector(selectAccountId)
  const { data: accountUserSettings } = useGetAccountUserSettingsQuery({ accountId })
  return accountUserSettings?.data?.settingsOverride?.timezone ?? DEFAULT_TIMEZONE
}
